import { createResource } from '@frappe-ui/resources/resources.js'

export function createSubmitFeedbackResource() {
  return createResource({
    url: 'retiora.api.feedback.submit_feedback',
    auto: false,
  })
}
